(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('GrowthDeleteController',GrowthDeleteController);

    GrowthDeleteController.$inject = ['$uibModalInstance', 'entity', 'Growth'];

    function GrowthDeleteController($uibModalInstance, entity, Growth) {
        var vm = this;

        vm.growth = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Growth.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
